import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormService } from '../../services/form.service';
import { AuthService } from '../auth.service';
import { FeedbackService } from '../../feedback/feedback.service';
import { Subscription } from 'rxjs';
import { EntryDictionary, LogInType } from '@generativ/ms-student-types';
import { ContentfulService } from '../../../shared/contentful.service';
import { RouterLink } from '@angular/router';
import { FeedbackComponent } from '../../feedback/feedback/feedback.component';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, RouterLink, FeedbackComponent]
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  resetForm: UntypedFormGroup;
  loading = true;
  content: LogInType;

  constructor(private formService: FormService,
              private feedbackService: FeedbackService,
              private authService: AuthService,
              private readonly contentfulService: ContentfulService
  ) {
    this.resetForm = this.formService.createForm(this.formOptions);
    this.contentfulService.getStudentEntry(EntryDictionary.LogIn.logIn).then(
      (entry) => {
        this.content = new LogInType(entry);
        this.loading = false;
      },
    );
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  submitForm() {
    if (this.formService.validateFormAndUpdateErrors(this.resetForm)) {
      this.loading = true;
      this.feedbackService.cleanState();
      this.subscriptions.add(this.authService.forgotPassword(this.resetForm.get('email').value)
        .subscribe(
          () => {
            this.loading = false;
            this.feedbackService.success('You will receive an email to change your password, if the account exists.', true);
          },
          () => {
            this.loading = false;
            // Auth0 is returning a success response that doesn't follow the expected format
            // This causes a parse error occurs. Show success message always.
            // TODO Create different handler on http call for resolving response
            this.feedbackService.success('You will receive an email to change your password, if the account exists.', true);
            // this.feedbackService.error(error, true);
          }
        ));
    }
  }

  private get formOptions(): Record<string, unknown> {
    return {
      email: [
        null,
        Validators.compose([
          Validators.required,
          Validators.email
        ])
      ],
    };
  }

}
